import { Box } from '@mui/material';
import CreateAccount from 'components/create-account/create-account.component';
import GuestForm from 'components/guest-form/guest-form.component';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CheckoutSectionEdit from '../checkout-section/checkout-section-edit/checkout-section-edit.component';
import CheckoutSection from '../checkout-section/checkout-section.component';
import CheckoutContactInfoSectionPreview from './checkout-contact-info-section-preview/checkout-contact-info-section-preview.component';
import {
  useCustomerSectionComponent,
  useCustomerValidation,
} from './checkout-contact-info-section.hooks';
import { useIsGuestCheckoutSupported } from 'components/payment/payment.new.hooks';
import GuestVerificationModal from './guest-verification-modal/guest-verification-modal.component';

const CheckoutContactInfoSection = ({ ...rest }) => {
  const { t } = useTranslation();
  const {
    customerInfo,
    submitCustomerInfo,
    formMethods,
    handleGuestComplete,
    isGuestCheckoutVerificationEnabled,
    isModalOpen,
    openModal,
    closeModal,
    resendCode,
    expirationMinutes,
    maskedRecipient,
    sendCode,
  } = useCustomerSectionComponent();
  const isGuestCheckoutSupported = useIsGuestCheckoutSupported();
  const { validate } = useCustomerValidation(!!expirationMinutes);

  return (
    <>
      <CheckoutSection
        title={t('checkout.customer.title')}
        onSubmit={submitCustomerInfo}
        validate={validate}
        data-testid="CheckoutContactInfoSection.CheckoutSection"
        changeButtonProps={{
          'aria-label': t(
            'checkout.section.changeButton.contactInfo.ariaLabel',
          ),
        }}
        {...rest}
      >
        {!!customerInfo ? (
          <>
            <CheckoutContactInfoSectionPreview
              openModal={openModal}
              sendCode={sendCode}
              maskedRecipient={maskedRecipient}
              expirationMinutes={expirationMinutes}
              isGuestCheckoutVerificationEnabled={
                isGuestCheckoutVerificationEnabled
              }
            />
            <CheckoutSectionEdit>
              <GuestForm methods={formMethods} customerInfo={customerInfo} />
            </CheckoutSectionEdit>
          </>
        ) : (
          <Box data-testid="CheckoutContactInfoSection.Box.Auth">
            <CreateAccount
              onComplete={handleGuestComplete}
              guest={isGuestCheckoutSupported}
              context={{ drawer: false }}
            />
          </Box>
        )}
      </CheckoutSection>
      {isGuestCheckoutVerificationEnabled && (
        <GuestVerificationModal
          open={isModalOpen}
          onClose={closeModal}
          maskedRecipient={maskedRecipient}
          expirationMinutes={expirationMinutes}
          onResend={resendCode}
        />
      )}
    </>
  );
};

export default CheckoutContactInfoSection;
